/**IMPORTANT LIBRARY IMPORTS */
import React from "react";

/**COMPONENTS IMPORT */
import PageHero from "../Components/PageHero";


const ServiceDetail=()=>{
    
    return(
        <>
         {/**HERO SECTION */}
        <PageHero heading={"Business Strategy"}/>
        </>
    )
}

export default ServiceDetail;